import { TABS, TASKS_LIST_PATH } from "@/modules/tasks/pages/tasks";
import { ASSETS_LIST_PATH } from "@/modules/assets/pages/assets-list";
import { MY_TEAM_ASSETS } from "@/modules/assets/pages/assets-list/tab-navigation";
import {
  DOCUMENT_REGISTER_LIST_PATH,
  DOCUMENT_REGISTER_MY_TEAM_TAB,
  DOCUMENT_REGISTER_TAB_PARAM,
} from "@/modules/document-register/pages/document-register-list-page";
import { CALENDAR_PATH } from "@/modules/calendar/pages/calendar";
import { EventVisibility } from "gql/graphql";

function withParams(path: string, params: Record<string, string>) {
  const search = new URLSearchParams(params).toString();

  return search ? `${path}?${search}` : path;
}

// "Показать все" / "Все" ведут на существующие экраны с фильтром "моя команда".
export const teamDashboardLinks = {
  tasks: withParams(TASKS_LIST_PATH, { tab: TABS.MY_TEAM }),
  // Календарь открываем с временным фильтром "команда" по отсутствиям и
  // знаковым событиям — мержится с настройками пользователя, но не сохраняется.
  calendar: withParams(CALENDAR_PATH, {
    absence: EventVisibility.MyTeam,
    milestone: EventVisibility.MyTeam,
  }),
  resources: withParams(ASSETS_LIST_PATH, { tab: MY_TEAM_ASSETS }),
  orders: withParams(DOCUMENT_REGISTER_LIST_PATH, {
    [DOCUMENT_REGISTER_TAB_PARAM]: DOCUMENT_REGISTER_MY_TEAM_TAB,
  }),
};
